import { BoxClose, BoxTitle, Header } from './styles'
import { IoClose } from 'react-icons/io5'
import logoTransparent from '../../../assets/images/logotransparent.png'

export default function ({ onClose }) {
  return (
    <Header>
      <BoxTitle>
        <div>
          <img src={logoTransparent} alt="Logo"></img>
          Lactec - Contato e orçamento
        </div>
      </BoxTitle>
      <BoxClose onClick={onClose}>
        <IoClose size={22} />
      </BoxClose>
    </Header>
  )
}
